import {CompetitionMatchesState, SportEventsByDateAction} from './types';
import {MatchDetailCleanup} from '../matchDetail/types';
import {
  MATCHDETAIL_CLEANUP,
  SPORTEVENTS_BY_SEASON_ID_GET_INVALIDATE,
  SPORTEVENTS_BY_SEASON_ID_GET_REQUEST,
  SPORTEVENTS_BY_SEASON_ID_GET_RESPONSE,
} from '../actionTypes';

const initialState: CompetitionMatchesState = {
  isFetching: false,
  didInvalidate: false,
};

/**
 * Derives the 'competitionMatches' state by reducing a new one every time an involved action is dispatches.
 * If the action is not involved (meaning it's not related with this state), then the state
 * is not changed.
 * @param state
 * @param action
 */
const competitionMatchesReducer = (state: CompetitionMatchesState = initialState, action: SportEventsByDateAction | MatchDetailCleanup): CompetitionMatchesState => {
  switch (action.type) {
    case SPORTEVENTS_BY_SEASON_ID_GET_REQUEST:
      return ({
        ...state,
        isFetching: true,
        error: undefined,
      });
    case SPORTEVENTS_BY_SEASON_ID_GET_RESPONSE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: action.payload.matches,
      });
    case SPORTEVENTS_BY_SEASON_ID_GET_INVALIDATE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.error,
      });
    case MATCHDETAIL_CLEANUP:
      return ({...initialState});
    default:
      return state;
  }
};

export default competitionMatchesReducer;
